import { Component, Input, ViewChild, OnInit, AfterViewInit, OnChanges } from '@angular/core';
import { AlunoSae } from '../aluno/aluno-sae';
import { AlunoSaeService } from '../aluno/aluno-sae.service';
import { Estudo } from '../estudo/estudo';
import { EstudoService } from '../estudo/estudo.service';
import { SituacaoEnum } from '../util/situacao.enum';
import { Router, ActivatedRoute } from '@angular/router';
import { MatPaginator, MatSort, Sort, MatDialog, MatTableDataSource, MatSnackBar,  PageEvent } from '@angular/material';
import { ConfirmacaoDialog } from '../util/confirmacao.dialog';
import { Confirmacao } from '../util/confirmacao';
import { Periodo } from '../util/periodo';
import { EstudoRenovacao } from './estudo-renovacao';
import { EstudoRenovacaoService } from './estudo-renovacao.service';
import { PontuacaoDialogComponent } from '../pontuacao/pontuacao-dialog.component';

@Component({
    templateUrl: './estudo-renovacao-list.component.html',
    selector: 'app-renovacao-estudo-list',
    styleUrls: [ './estudo-renovacao-list.component.css' ]
})
export class EstudoRenovacaoListComponent implements OnInit, AfterViewInit {

    public filtro: EstudoRenovacao = new EstudoRenovacao();
    public ordenar: string;
    public lista: EstudoRenovacao[];

    @Input() mostrarFiltro = true;

    public columnsToDisplay = [
      'id',
      'alunoNome',
      'matricula',
      'renovado',
      'alteracaoBeneficio',
      'usuarioResponsavel',
      'periodo',
      'acao'
    ];
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    public dataSource = new MatTableDataSource<EstudoRenovacao>(this.lista);
    public pageSize = 10;
    public offset: number;
    
    // MatPaginator Output
    pageEvent: PageEvent;

    // controla o loading da pagina
    // private isLoading: boolean;
    public isLoading: boolean;


    // construtor
    constructor(private estudoRenovacaoService: EstudoRenovacaoService,
      public mensagem: MatSnackBar, public dialog: MatDialog) {   }

    // ngOnInit é executado ao entrar na tela
    ngOnInit() {
      // this.buscar(this.filtro);
    }

    ngAfterViewInit() {
      this.dataSource.paginator = this.paginator;
    }

    // busca com filtro
    public buscar(filtro: EstudoRenovacao): void {
      this.isLoading = true;
      this.estudoRenovacaoService.filtrar(filtro, this.ordenar).subscribe(
        res => {
          this.lista = res;
          this.dataSource = new MatTableDataSource<EstudoRenovacao>(res);
          this.dataSource.paginator = this.paginator;
          this.dataSource.sort = this.sort;
          this.isLoading = false;
        },
        error =>  this.erro(error)
      );
    }

    filtroEmitido(filtro: EstudoRenovacao) {
      this.filtro = filtro;
      this.buscar(this.filtro);
    }

   
    public filtrarDinamico(filterValue: string): void {
      filterValue = filterValue.trim(); // Remove whitespace
      filterValue = filterValue.toLowerCase(); // MatTableDataSource defaults to lowercase matches
      this.dataSource.filter = filterValue;
    }


    public sortData(sort: any) {
      if (!sort.active || sort.direction === '') {
        return;
      } else {
        this.ordenar = sort.active + ' ' + sort.direction ;
        this.buscar(this.filtro);
      }
    }

    public excluir(objeto: EstudoRenovacao) {
      let mensagem: string = "Deseja excluir o registro? ";
      let dialogRef = this.dialog.open(ConfirmacaoDialog, {
        width: "400px",
        data: mensagem
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.deletar(objeto);
        }
      });
    }

    private deletar(objeto: EstudoRenovacao) {
      this.isLoading = true;
      this.estudoRenovacaoService.deletar(objeto).subscribe(
        result => {
          this.mensagem.open("Registro excluído com sucesso!", "X", {
            duration: 5000
          });
          this.buscar(this.filtro);
        },
        error => this.erro(error)
      );
    }


    public pontuaAutomatico(objeto: EstudoRenovacao) {
      this.isLoading = true;
      this.estudoRenovacaoService.pontuaAutomatico(objeto).subscribe(
        result => {
          this.mensagem.open("Registro renovado com sucesso!", "X", {
            duration: 5000
          });
          this.buscar(this.filtro);
        },
        error => this.erro(error)
      );
    }

    public pontuaManual(objeto: EstudoRenovacao) {
      this.isLoading = true;
      this.estudoRenovacaoService.pontuaManual(objeto).subscribe(
        (result:EstudoRenovacao) => {
          this.atualizaLista(result);
          this.abrirPopUpPontuacao(result);
          this.isLoading = false;
        },
        error => this.erro(error)
      );
    }

    public atualizaLista(estudoRenovado: EstudoRenovacao){
          // atualizo minha lista com o usuário responsável
          this.lista.forEach(renovado => {
            if(renovado.id == estudoRenovado.id){
              /*renovado.usuarioResponsavel = estudoRenovado.usuarioResponsavel;
              renovado.idNovoEstudo = estudoRenovado.idNovoEstudo;*/
              renovado = estudoRenovado;
            } 
         })
    }

    public abrirPopUpPontuacao(objeto: EstudoRenovacao) {

      if(!objeto.idNovoEstudo){
        this.mensagem.open("Erro ao carregar id do novo estudo! Tente recarregar a página.", "X", {duration: 5000});
        return;
      }

      let dialogRef = this.dialog.open(PontuacaoDialogComponent, {
        width: "1680px",
        height: "800px",
        data: objeto.idNovoEstudo,
        disableClose: true
      });
  
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.finalizaRenovacao(objeto);
        }
      });
    }

   finalizaRenovacao(objeto: EstudoRenovacao){
    // altero para renovado 
    objeto.renovado = true;
    // e salvo
    this.isLoading = true;
    this.estudoRenovacaoService.getId(objeto.id).subscribe (
      (result:EstudoRenovacao) => {
        if(result.renovado == true){
          this.mensagem.open("Estudo já foi renovado. Por favor, atualize a tela.", "X", {duration: 5000});
        }else{
          this.alteraSituacao(objeto);          
        }
      },
      error => this.erro(error)
    );
   }

    private alteraSituacao(objeto: EstudoRenovacao){
      this.estudoRenovacaoService.update(objeto).subscribe(
        (result:EstudoRenovacao) => {
          this.mensagem.open("Renovação Finalizada! O status foi alterado para Renovado.", "X", {duration: 5000});
          this.atualizaLista(result);
          this.isLoading = false;        
        },
        error => this.erro(error)
      );
    }

    // mostra erros na tela
   erro(erro: string) {
     this.mensagem.open(erro, 'X', {duration: 5000});
     this.isLoading = false;
   }
}
